import { Element, Node } from "@siteimprove/alfa-dom";
import { Style } from "../../style.js";
const { isElement } = Element;
/**
 * @public
 */
export function hasCascadedStyle(name, predicate, device, context) {
    return function hasCascadedStyle(node) {
        return isElement(node)
            ? Style.from(node, device, context)
                .cascaded(name)
                .some((value) => value.some(predicate))
            : node.parent(Node.flatTree).filter(isElement).some(hasCascadedStyle);
    };
}
//# sourceMappingURL=has-cascaded-style.js.map